import App from './javascript/app.js';

const app = new App('#app');
app.run();